import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import * as Yup from "yup";
// import Account from "/Biztran Dropbox/CTO Biztran Solutions/191 Server Developers/Kunal/New Pmcrm/PMCRM_P/ClientApp/src/components/masters/accounts/Account.js"
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateOpportunity = (props) => {
  const classes = useStyles();
  const [Mode, setMode] = useState("");
  const [OpportunityNo, setOpportunityNo] = useState("");
  const [OpportunityDate, setOpportunityDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [PredictedClosingDate, setPredictedClosingDate] = useState();
  const [CompanyID, setCompanyID] = useState();
  const [AccountID, setAccountID] = useState();
  const [LeadID, setLeadID] = useState();
  const [LeadSourceID, setLeadSourceID] = useState();
  const [ContactID, setContactID] = useState();
  const [OpportunityStage, setOpportunityStage] = useState("New");
  // const [TotalAmount, setTotalAmount] = useState();
  const [GstAmount, setGstAmount] = useState();
  const [Description, setDescription] = useState("");
  const [BillAddress1, setBillAddress1] = useState("");
  const [BillAddress2, setBillAddress2] = useState("");
  const [BillCity, setBillCity] = useState("");
  const [Disabled, setDisable] = useState(false);
  const [BillCountryID, setBillCountryID] = useState();
  const [BillStateID, setBillStateID] = useState();
  const [BillPINCode, setBillPINCode] = useState("");
  const [ShipAddress1, setShipAddress1] = useState("");
  const [ShipAddress2, setShipAddress2] = useState("");
  const [ShipCity, setShipCity] = useState("");
  const [ShipCountryID, setShipCountryID] = useState();
  const [ShipStateID, setShipStateID] = useState();
  const [ShipPINCode, setShipPINCode] = useState("");
  const [Leadcmb, setLeadcmb] = useState([]);
  const [Companycmb, setCompanycmb] = useState([]);
  const [Accountcmb, setAccountcmb] = useState([]);
  const [Contactcmb, setContactcmb] = useState([]);
  const [LeadSourcecmb, setLeadSourcecmb] = useState([]);
  const [BillCountrycmb, setBillCountrycmb] = useState([]);
  const [BillStatecmb, setBillStatecmb] = useState([]);
  const [ShipCountrycmb, setShipCountrycmb] = useState([]);
  const [ShipStatecmb, setShipStatecmb] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  // const [isDoubleChecked,setisDoubleChecked] = useState(false);
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [responseAccDtls, fetchAccDtlsData] = UseFetchData();
  const [responsContactDtls, fetchContactDtlsData] = UseFetchData();
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);
  const [DisableSaveBtn, setDisableSaveBtn] = useState(false);
  const [StateData, setStateData] = useState("");



  const GetAccountData = (AccountID) => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("AccountID", AccountID);
    // setLoading(true);
    fetchAccDtlsData("Account/GetByID", bodyFormData);
  };

  const validationSchema = Yup.object({
    OpportunityDate: Yup.string().required("Required!"),
    PredictedClosingDate: Yup.string().required("Required!"),
    // TotalAmount: Yup.string().required("Required!"),
    AccountID: Yup.string().required("Required!"),
    LeadSourceID: Yup.string().required("Required!"),
    ContactID: Yup.string().required("Required!"),
  });


  const onSubmit = (values) => {
    setMode("Insert");
    debugger;
    var UpdatedByID = sessionStorage.UID;
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunityID", props.OpportunityID);
    bodyFormData.append("OpportunityNo", values.OpportunityNo);
    bodyFormData.append("OpportunityDate", values.OpportunityDate);
    // bodyFormData.append("LeadID", values.LeadID);
    bodyFormData.append("AccountID", values.AccountID);
    bodyFormData.append("ContactID", values.ContactID);
    bodyFormData.append("CompanyID", values.CompanyID);
    bodyFormData.append("LeadSourceID", values.LeadSourceID);
    bodyFormData.append("OpportunityType", '');
    bodyFormData.append("OpportunityStage", values.OpportunityStage);
    bodyFormData.append("GeneratedByID", UpdatedByID);
    bodyFormData.append("HandledByID", UpdatedByID);
    bodyFormData.append("PredictedClosingDate", values.PredictedClosingDate);
    bodyFormData.append("Description", values.Description);
    bodyFormData.append("GstAmount", '');
    bodyFormData.append("BillAddress1", values.BillAddress1);
    bodyFormData.append("BillAddress2", values.BillAddress2);
    bodyFormData.append("BillCity", values.BillCity);
    bodyFormData.append("BillCountryID", values.BillCountryID);
    bodyFormData.append("BillStateID", values.BillStateID);
    bodyFormData.append("BillPINCode", values.BillPINCode);
    if (values.ShipAddress1 == null) {
      var BString = "";
      bodyFormData.append("ShipAddress1", BString);

    } else {
      bodyFormData.append("ShipAddress1", values.ShipAddress1);

    }
    if (values.ShipAddress2 == null) {
      var BString = "";
      bodyFormData.append("ShipAddress2", BString);

    } else {
      bodyFormData.append("ShipAddress2", values.ShipAddress2);

    }
    if (values.ShipCity == null) {
      var BString = "";
      bodyFormData.append("ShipCity", BString);

    } else {
      bodyFormData.append("ShipCity", values.ShipCity);

    }
    if (values.ShipCountryID == null) {
      var BString = "";
      bodyFormData.append("ShipCountryID", BString);

    } else {
      bodyFormData.append("ShipCountryID", values.ShipCountryID);

    }
    if (values.ShipStateID == null) {
      var BString = "";
      bodyFormData.append("ShipStateID", BString);

    } else {
      bodyFormData.append("ShipStateID", values.ShipStateID);

    }
    if (values.ShipPINCode == null) {
      var BString = "";
      bodyFormData.append("ShipPINCode", BString);

    } else {
      bodyFormData.append("ShipPINCode", values.ShipPINCode);

    }
    bodyFormData.append("UpdatedByID", UpdatedByID);
    setDisableSaveBtn(true);
    fetchData("Opportunity/Save", bodyFormData);
  };


  const GetComboData = () => {
    fetchComboData("Opportunity/ComboData");
  };

  const OpportunityStageOption = [
    { key: "New", value: "New" },
    { key: "Quotation", value: "Quotation" },
  ];

  const OpportunityStageData = () => {
    let OpportunityStage = OpportunityStageOption.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return OpportunityStage;
  };

  const LeadData = (options) => {
    if (options !== undefined) {
      let Lead = options.map((data) => (
        <option key={data.LeadNo} value={data.LeadID}>
          {data.LeadNo}
        </option>
      ));
      setLeadcmb(Lead);
    }
  };
  const AccountData = (options) => {
    if (options !== undefined) {
      let Account = options.map((data) => (
        <option key={data.AccountName} value={data.AccountID}>
          {data.AccountName}
        </option>
      ));
      setAccountcmb(Account);
    }
  };
  const ContactData = (options) => {
    if (options !== undefined) {
      let Contact = options.map((data) => (
        <option key={data.ContactName} value={data.ContactID}>
          {data.ContactName}
        </option>
      ));
      setContactcmb(Contact);
    }
  };
  const LeadSourceData = (options) => {
    if (options !== undefined) {
      let LeadSource = options.map((data) => (
        <option key={data.LeadSource} value={data.LeadSourceID}>
          {data.LeadSource}
        </option>
      ));
      setLeadSourcecmb(LeadSource);
    }
  };
  const BillStatecmbData = (CID) => {
    debugger;
    var id = "";
    if (CID !== "") {
      id = CID;
    } else if (BillCountryID !== "" && BillCountryID !== undefined) {
      id = BillCountryID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["State"];
    if (options !== undefined) {
      if (id !== "") {
        let State = options
          .filter((option) => option.CountryID === id)
          .map((data) => (
            <option key={data.StateName} value={data.StateID}>
              {data.StateName}
            </option>
          ));
        setBillStatecmb(State);
      }
      else {
        let State = options.map((data) => (
          <option key={data.StateName} value={data.StateID}>
            {data.StateName}
          </option>
        ));
        setBillStatecmb(State);
      }
    }
  };



  const CountryData = (options) => {
    if (options !== undefined) {
      let Country = options.map((data) => (
        <option key={data.Country} value={data.CountryID}>
          {data.Country}
        </option>
      ));
      setBillCountrycmb(Country);
      setShipCountrycmb(Country);
    }
  };

  const CompanyData = (options) => {
    if (options !== undefined) {
      let Company = options.map((data) => (
        <option key={data.CompanyName} value={data.CompanyID}>
          {data.CompanyName}
        </option>
      ));
      setCompanycmb(Company);
    }
  };


  const ShipStatecmbData = (CID) => {
    debugger;
    var id = "";
    if (CID !== "") {
      id = CID;
    } else if (BillCountryID !== "" && BillCountryID !== undefined) {
      id = BillCountryID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["State"];
    if (options !== undefined) {
      if (id !== "") {
        let State = options
          .filter((option) => option.CountryID === id)
          .map((data) => (
            <option key={data.StateName} value={data.StateID}>
              {data.StateName}
            </option>
          ));
        setShipStatecmb(State);
      }
      else {
        let State = options.map((data) => (
          <option key={data.StateName} value={data.StateID}>
            {data.StateName}
          </option>
        ));
        setShipStatecmb(State);
      }
    }
  };


  const GetOpportunityData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunityID", props.OpportunityID);
    fetchData("Opportunity/GetByID", bodyFormData);
  };

  const GetContactData = (AccountID) => {
    debugger
    var bodyFormData = new FormData();
    if (AccountID != undefined && AccountID != "") {
      var acid = AccountID;
    }
    bodyFormData.append("AccountID", acid);
    // bodyFormData.append("AccountID", AccountID);
    // setLoading(true);
    fetchContactDtlsData("Opportunity/GetCotactDtlsByAccID", bodyFormData);
  };

  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };

  useEffect(() => {
    // debugger;
    if (isChecked) {
      setShipAddress1(BillAddress1);
      setShipAddress2(BillAddress2);
      setShipCountryID(BillCountryID);
      setShipStateID(BillStateID);
      setShipCity(BillCity);
      setShipPINCode(BillPINCode);
    }
    else if (props.QuotationID !== undefined && ShipAddress1 !== "") {
      setShipAddress1(BillAddress1);
      setShipAddress2(BillAddress2);
      setShipCountryID(BillCountryID);
      setShipStateID(BillStateID);
      setShipCity(BillCity);
      setShipPINCode(BillPINCode);
    }
    else {
      setShipAddress1("");
      setShipAddress2("");
      setShipCountryID("");
      setShipStateID("");
      setShipCity("");
      setShipPINCode("");
    }

  }, [isChecked]);


  useEffect(() => {
    if (response.Response === true) {
      props.setOpen(false);
      // debugger;
      props.PopulateData();
      alert("Data Saved Successfully")
      setDisableSaveBtn(true);
    }
    else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      }
      else {
        alert("Failed.");
        setDisableSaveBtn(false);

      }
    }
    if (props.OpportunityID !== "") {
      // setMode("Update");
    } else {
      setMode("Insert");
    }

    if (response.length > 0 && Mode === "Update") {
      setOpportunityNo(response[0].OpportunityNo);
      setOpportunityDate(
        response[0].OpportunityDate === null
          ? ""
          : Moment(response[0].OpportunityDate).format("YYYY-MM-DD")
      );
      setLeadID(response[0].LeadID === null ? "" : response[0].LeadID);
      setCompanyID(response[0].CompanyID === null ? "" : response[0].CompanyID);
      setAccountID(response[0].AccountID === null ? "" : response[0].AccountID);
      GetContactData(response[0].AccountID === null ? "" : response[0].AccountID);
      setLeadSourceID(
        response[0].LeadSourceID === null ? "" : response[0].LeadSourceID
      );
      setPredictedClosingDate(
        response[0].PredictedClosingDate === null
          ? ""
          : Moment(response[0].PredictedClosingDate).format("YYYY-MM-DD")
      );
      // setTotalAmount(response[0].TotalAmount === null ? "" : response[0].TotalAmount);
      setGstAmount(response[0].GstAmount === null ? "" : response[0].GstAmount);
      setDescription(response[0].Description === null ? "" : response[0].Description);
      setBillAddress1(response[0].BillAddress1 === null ? "" : response[0].BillAddress1);
      setShipAddress1(response[0].ShipAddress1 === null ? "" : response[0].ShipAddress1);
      setBillAddress2(response[0].BillAddress2 === null ? "" : response[0].BillAddress2);
      setShipAddress2(response[0].ShipAddress2 === null ? "" : response[0].ShipAddress2);
      setBillCity(response[0].BillCity === null ? "" : response[0].BillCity);
      setBillStateID(
        response[0].BillStateID === null ? "" : response[0].BillStateID
      );
      setShipCity(response[0].ShipCity === null ? "" : response[0].ShipCity);
      setShipStateID(
        response[0].ShipStateID === null ? "" : response[0].ShipStateID
      );
      setBillPINCode(response[0].BillPINCode === null ? "" : response[0].BillPINCode);
      setBillCountryID(
        response[0].BillCountryID === null ? "" : response[0].BillCountryID
      );
      setShipPINCode(response[0].ShipPINCode === null ? "" : response[0].ShipPINCode);
      setShipCountryID(
        response[0].ShipCountryID === null ? "" : response[0].ShipCountryID
      );
      setContactID(response[0].ContactID === null ? "" : response[0].ContactID);

    }
  }, [response]);

  useEffect(() => {
    if (responseAccDtls !== undefined && responseAccDtls.length > 0) {
      setBillAddress1(responseAccDtls[0].BillAddress1 === null ? "" : responseAccDtls[0].BillAddress1);
      setBillAddress2(responseAccDtls[0].BillAddress2 === null ? "" : responseAccDtls[0].BillAddress2);
      setBillCity(responseAccDtls[0].BillCity === null ? "" : responseAccDtls[0].BillCity);
      setBillCountryID(responseAccDtls[0].BillCountryID === null ? "" : responseAccDtls[0].BillCountryID);
      setBillStateID(responseAccDtls[0].BillStateID === null ? "" : responseAccDtls[0].BillStateID);
      setBillPINCode(responseAccDtls[0].BillPINCode);
      setShipAddress1(responseAccDtls[0].ShipAddress1 === null ? "" : responseAccDtls[0].ShipAddress1);
      setShipAddress2(responseAccDtls[0].ShipAddress2 === null ? "" : responseAccDtls[0].ShipAddress2);
      setShipCity(responseAccDtls[0].ShipCity === null ? "" : responseAccDtls[0].ShipCity);
      setShipCountryID(responseAccDtls[0].ShipCountryID === null ? "" : responseAccDtls[0].ShipCountryID);
      setShipStateID(responseAccDtls[0].ShipStateID === null ? "" : responseAccDtls[0].ShipStateID);
      setShipPINCode(responseAccDtls[0].ShipPINCode);
    }

  }, [responseAccDtls])


  useEffect(() => {
    if (responsContactDtls !== undefined && responsContactDtls.length > 0) {
      ContactData(responsContactDtls);
    }
  }, [responsContactDtls]);

  useEffect(() => {
    debugger;
    if (ComboDataResponse !== undefined) {
      if (
        ComboDataResponse["Lead"] !== undefined &&
        ComboDataResponse["Account"] !== undefined &&
        ComboDataResponse["LeadSource"] !== undefined &&
        ComboDataResponse["Country"] !== undefined &&
        ComboDataResponse["Company"] !== undefined
        // ComboDataResponse["State"] !== undefined
      ) {
        LeadData(ComboDataResponse["Lead"]);
        AccountData(ComboDataResponse["Account"]);
        LeadSourceData(ComboDataResponse["LeadSource"]);
        CountryData(ComboDataResponse["Country"]);
        CompanyData(ComboDataResponse["Company"]);
        // if (ComboDataResponse['State'] !== undefined && ComboDataResponse['State'].length > 0) {
        //   // setLoadinsg(false);
        //   setStateData(ComboDataResponse['State']);
        // } else {
        //   setStateData([]);
        // }

        if (props.OpportunityID !== "") {
          BillStatecmbData("");
          ShipStatecmbData("");
          setMode("Update");
          GetOpportunityData();
        } else {
          setMode("Insert");
          BillStatecmbData("");
          ShipStatecmbData("");

        }
      }
    }
  }, [ComboDataResponse]);




  useEffect(() => {
    GetComboData();
    if (props.LeadID !== "" && props.LeadID !== undefined) {
      // setLeadID(props.LeadID);
      setDisable(false);
    }
    if (props.OpportunityID !== "" && props.disabled === true) {
      setDisable(false);
    } else if (props.disabled === false) {
      setDisable(false);
    } else if (props.OpportunityID === "" && props.disabled === true) {
      setDisable(true);
    }
  }, []);


  const onCheckChange = (e) => {
    // debugger;

    setIsChecked(e.target.checked);
    console.log(isChecked);
  };


  const onSelectChange = (e) => {
    debugger;
    //e.target.selectedOptions[0].label
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      if (targetname === "AccountID") {
        setAccountID(targetvalue);
        GetAccountData(targetvalue);
        GetContactData(targetvalue);
        // BillStatecmbData();
      } else if (targetname === "CompanyID") {
        setCompanyID(targetvalue);
      }
      else if (targetname === "LeadID") {
        setLeadID(targetvalue);
      }
      else if (targetname === "LeadSourceID") {
        setLeadSourceID(targetvalue);
      } else if (targetname === "ContactID") {
        setContactID(targetvalue);
      } else if (targetname === "BillCountryID") {
        setBillCountryID(targetvalue);
        BillStatecmbData(targetvalue);
        // BillStatecmb([]);
      } else if (targetname === "BillStateID") {
        setBillStateID(targetvalue);
      } else if (targetname === "ShipCountryID") {
        setShipCountryID(targetvalue);
        ShipStatecmbData(targetvalue);
      } else if (targetname === "ShipStateID") {
        setShipStateID(targetvalue);
      }
    }
    else {
      if (targetname === "AccountID") {
        setAccountID("");
        // GetAccountData("");
        GetContactData("");
        ContactData([]);
        setBillAddress1('');
        setBillAddress2('');
        setBillCity('');
        setBillCountryID('');
        setBillStateID('');
        setBillPINCode('');
        setShipAddress1('');
        setShipAddress2('');
        setShipCity('');
        setShipCountryID('');
        setShipStateID('');
        setShipPINCode('');
      } else if (targetname === "CompanyID") {
        setCompanyID("");
      }
      else if (targetname === "LeadID") {
        setLeadID("");
      }
      else if (targetname === "LeadSourceID") {
        setLeadSourceID("");
      } else if (targetname === "ContactID") {
        setContactID("");
      } else if (targetname === "BillCountryID") {
        setBillCountryID("");
        setBillStatecmb([]);
        setBillStateID("");
      } else if (targetname === "BillCountryID") {
        setBillCountryID("");
        setBillStatecmb([]);
      } else if (targetname === "BillStateID") {
        setBillStateID("");
      } else if (targetname === "ShipCountryID") {
        setShipStateID("");
        setShipStateID([]);
      } else if (targetname === "ShipStateID") {
        setShipStateID("");
      }
    }
  };

  let OpportunityStagecmb = OpportunityStageData();

  return (
    <div>
      <Formik
        initialValues={{
          OpportunityNo: OpportunityNo,
          OpportunityDate: OpportunityDate,
          CompanyID: CompanyID,
          LeadID: LeadID,
          AccountID: AccountID,
          ContactID: ContactID,
          LeadSourceID: LeadSourceID,
          OpportunityStage: OpportunityStage,
          PredictedClosingDate: PredictedClosingDate,
          // TotalAmount: TotalAmount,
          GstAmount: GstAmount,
          Description: Description,
          BillAddress1: BillAddress1,
          ShipAddress1: ShipAddress1,
          BillAddress2: BillAddress2,
          ShipAddress2: ShipAddress2,
          BillCity: BillCity,
          BillStateID: BillStateID,
          ShipCity: ShipCity,
          ShipStateID: ShipStateID,
          BillPINCode: BillPINCode,
          BillCountryID: BillCountryID,
          ShipPINCode: ShipPINCode,
          ShipCountryID: ShipCountryID,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Typography className={classes.headertext} noWrap>
                Opportunity Information
              </Typography>
              <Grid spacing={2} container direction="row">
                <Grid item xs={1.5}>
                  <label
                    htmlFor={"OpportunityNo"}
                    style={{
                      display: "block",
                      width: "100%"
                    }}
                  >
                    {"Opportunity No"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="OpportunityNo"
                    disabled={true}
                    onChange={(e) => setOpportunityNo(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1.5}>
                  <label
                    htmlFor={"OpportunityDate"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Opportunity Date"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="input"
                    type="date"
                    name="OpportunityDate"
                    disabled={true}
                    onChange={(e) => setOpportunityDate(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1.5} style={{ marginRight: 21 }}>
                  <label
                    htmlFor={"CompanyID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Company"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    name="CompanyID"
                    options={Companycmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={1.5} style={{ marginRight: 15 }}>
                  <label
                    htmlFor={"LeadSourceID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Lead Source"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    name="LeadSourceID"
                    options={LeadSourcecmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={1.5} style={{ marginRight: 60 }}>
                  <label
                    htmlFor={"ContactID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Contact"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    name="ContactID"
                    options={Contactcmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={1.5} style={{ marginRight: 30 }}>
                  <label
                    htmlFor={"AccountID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Account"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    name="AccountID"
                    options={Accountcmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={1.5} style={{ marginRight: 60 }}>
                  <label
                    htmlFor={"OpportunityStage"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Stage"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    options={OpportunityStagecmb}
                    name="OpportunityStage"
                    disabled={true}
                    onChange={(e) => setOpportunityStage(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1.5} style={{ marginRight: 5 }}>
                  <label
                    htmlFor={"PredictedClosingDate"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"PreClosing Date"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="input"
                    type="date"
                    name="PredictedClosingDate"
                    onChange={(e) => setPredictedClosingDate(e.target.value)}
                  />
                </Grid>
                {/* <Grid item xs={2}>
                  <label
                    htmlFor={"TotalAmount"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Total Amount"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="input"
                    type="number"
                    name="TotalAmount"
                    onChange={(e) => setTotalAmount(e.target.value)}
                  />
                </Grid> */}
                {/* <Grid item xs={12} container direction='row'>
                  <Grid item xs={2}>
                    <label
                      htmlFor={"Description"}
                      style={{
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {"Description"}
                    </label>
                  </Grid>

                  <Grid item xs={10}>
                    <BiztranControlsFormik
                      // autoFocus="autofocus"
                      control="textarea"
                      type="text"
                      name="Description"
                      ref={ref}
                      value={Description}
                      onChange={(e) => {
                        setDescription(e.target.value)
                        handleChange()
                      }}
                    />
                  </Grid>
                </Grid> */}
              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid item xs={12}></Grid>
                <Grid item xs={12}>
                  <Typography className={classes.headertext} noWrap>
                    Address Information
                  </Typography>
                </Grid>
                <Grid item xs={8} style={{ display: "flex", marginLeft: "50%" }}>
                  <label>Shipping Address Same as Billing Address ?</label>
                  <div style={{ paddingLeft: 10 }}>
                    <input
                      type="checkbox"
                      name="chkbox"
                      checked={isChecked}
                      onChange={onCheckChange}
                    ></input>
                  </div>
                </Grid>
                {/* <Grid item xs={6} style={{ display: "flex" }}>
                  <label>Billing Address Same as Shipping Address?</label>
                  <div style={{ paddingRight: 10 }}>
                    <input
                      type="checkbox"
                      name="chkbox"
                      checked={isDoubleChecked}
                      onChange={onDoubleCheckChange}
                    ></input>
                  </div>
                </Grid> */}
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    label="Bill Address1"
                    name="BillAddress1"
                    ref={ref}
                    value={BillAddress1}
                    onChange={(e) => {
                      setBillAddress1(e.target.value)
                      handleChange()
                    }
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    label="Bill Address2"
                    name="BillAddress2"
                    ref={ref}
                    value={BillAddress2}
                    onChange={(e) => {
                      setBillAddress2(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    label="Ship Address1"
                    name="ShipAddress1"
                    ref={ref}
                    value={ShipAddress1}
                    onChange={(e) => {
                      setShipAddress1(e.target.value)
                      handleChange()
                    }
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    label="Ship Address2"
                    name="ShipAddress2"
                    ref={ref}
                    value={ShipAddress2}
                    onChange={(e) => {
                      setShipAddress2(e.target.value)
                      handleChange()
                    }
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    label="Bill Country"
                    name="BillCountryID"
                    options={BillCountrycmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    label="Bill State"
                    name="BillStateID"
                    options={BillStatecmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                {/* {label == true ?
                    <label
                      htmlFor={"Please enter state"}
                      style={{
                        display: "block",
                        width: "100%",
                        color: 'red',
                        marginTop: 15,
                        marginLeft: 10,
                        fontSize: 10,
                      }}
                    >
                      {"Please enter state"}
                    </label>
                    : null
                  } */}
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    label="Ship State"
                    name="ShipStateID"
                    options={ShipStatecmb}
                    onChange={onSelectChange}
                  />
                </Grid>


                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    label="Ship Country"
                    name="ShipCountryID"
                    options={ShipCountrycmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    label="Bill City"
                    name="BillCity"
                    ref={ref}
                    value={BillCity}
                    onChange={(e) => {
                      setBillCity(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="number"
                    label="Bill PIN Code"
                    name="BillPINCode"
                    ref={ref}
                    value={BillPINCode}
                    onChange={(e) => {
                      setBillPINCode(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    label="Ship City"
                    name="ShipCity"
                    ref={ref}
                    value={ShipCity}
                    onChange={(e) => {
                      setShipCity(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="number"
                    label="Ship PIN Code"
                    name="ShipPINCode"
                    ref={ref}
                    value={ShipPINCode}
                    onChange={(e) => {
                      setShipPINCode(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      {/* < BiztranControls.Button
                      text="Revise"
                      type="submit"
                      // startIcon={<SaveIcon />}
                      startIcon={<SwapHorizIcon />}
                    /> */}
                      <BiztranControls.Button
                        text="SAVE"
                        type="submit"
                        disabled={DisableSaveBtn}
                        startIcon={<SaveIcon />}
                      />
                      <BiztranControls.Button
                        text="CLOSE"
                        startIcon={<CloseIcon />}
                        onClick={() => {
                          props.setOpen(false);
                        }}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
  },
}));

export default CreateOpportunity;
